import { createSelector } from 'reselect'

const getState = state => state.users

export const getArtistsSelector = createSelector(
  getState,
  ({ artists }) => artists
)
export const getCuratorsSelector = createSelector(
  getState,
  ({ curators }) => curators
)
export const getUsersCount = createSelector(
  getState,
  ({ usersCount }) => usersCount
)
export const getFoundUsers = createSelector(
  getState,
  ({ foundUsers }) => foundUsers
)
